export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-video.vue?vue&type=template&id=573e3156&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-video/lk-video.vue?vue&type=template&id=573e3156&
// module id = 1374
// module chunks = 0